import { render, staticRenderFns } from "./profileAvatar.vue?vue&type=template&id=02d754ac&scoped=true&"
import script from "./profileAvatar.vue?vue&type=script&lang=js&"
export * from "./profileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./profileAvatar.vue?vue&type=style&index=0&id=02d754ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d754ac",
  null
  
)

export default component.exports